import React from 'react';
import SportsbookMarket from 'sportsbook-market-component';
import Outcomes from '../outcomes';
import presentOutcome from '../../presenters/outcome';

export default (props) => (
  <SportsbookMarket
    {...props}
    className="market-view-body-wrapper outcome-3cols"
    outcomeClassName="bvs-button-sport outcome-button-1x2"
    presentOutcome={(outcome) => presentOutcome(outcome, { layout: 'horizontal' })}
  >
    <Outcomes />
  </SportsbookMarket>
);
